package com.anjuros.website.templates.template1.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.MenuIcon
import com.anjuros.website.templates.template1.modules.Template1Section
import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.modules.getColor
import com.anjuros.website.templates.template1.modules.getColorOpacity
import com.anjuros.website.templates.template1.styles.CompanyColorVar
import com.anjuros.website.templates.template1.styles.Template1NavigationItemStyle
import com.anjuros.website.templates.template1.util.Template1Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template1Header(
    modifier: Modifier,
    onMenuCLicked:()->Unit){

    Box(modifier = modifier.fillMaxWidth() ) {
        Row(
            modifier = Modifier.fillMaxWidth()
                .margin(topBottom = 30.px).align(Alignment.TopEnd),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.Top
        ) {

            LeftSide() { onMenuCLicked() }
            RightSide()
        }
    }
}




@Composable
fun LeftSide(
             onMenuCLicked:()->Unit){
    Row(verticalAlignment = Alignment.CenterVertically) {

        MenuIcon(
            modifier = Modifier
                .zIndex(3.0)
                .displayUntil(Breakpoint.LG)
                .margin(left = 15.px)
                .color(Colors.White)
                .onClick { onMenuCLicked() }
        )
    }
}

@Composable
fun RightSide() {
    val color = Colors.White
    Row(
        modifier = Modifier
            .displayIfAtLeast(Breakpoint.LG)
            .borderRadius(topLeft =  50.px, topRight = 0.px, bottomLeft = 50.px, bottomRight = 0.px)
            .backgroundColor(Template1Theme.OpacityPrimary.getColorOpacity())
            .zIndex(3.0f)
            .padding(left=30.px, bottom=20.px, top=20.px, right=0.px)
        , horizontalArrangement = Arrangement.End
    ) {

        Template1Section.entries.toTypedArray().forEach {section->
            Link(
                modifier = Modifier
                    .textDecorationLine(TextDecorationLine.None),
                path = section.path
            ){
                P(
                    attrs = Template1NavigationItemStyle.toModifier()
                        .setVariable(CompanyColorVar, color)
                        .padding(right = 30.px)
                        .margin(topBottom = 0.px)
                        .fontFamily(Template1Constants.FONT_FAMILY)
                        .fontSize(18.px)
                        .fontWeight(FontWeight.Normal)
                        .toAttrs()
                ) {
                    Text(LocalText(section.title))

                }
            }

        }

    }
}